import { ref, computed } from "vue";

export function useLocalDataGrid(props) {
  const searchParam = ref("");
  const componentKey = ref(0);
  const preselectedSearchParam = ref("");

  const sortedData = computed(() =>{
    const searchBy = props.searchBy;
    return props.data.filter(role => role[searchBy].toLowerCase().includes(searchParam.value.toLowerCase()));
  });

  const resetSearch = () => {
    searchParam.value = "";
    preselectedSearchParam.value = "";
  };

  const submitSearch = (val) => {
    preselectedSearchParam.value = "";
    searchParam.value = val;
  };

  const clearSort = () => {
    searchParam.value = "";
    componentKey.value += 1;
  };

  const isSortable = (value) => {
    return value === "true";
  };

  return {
    resetSearch,
    submitSearch,
    clearSort,
    componentKey,
    isSortable,
    preselectedSearchParam,
    sortedData
  };
}
